import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import { Divider } from 'antd'

export const FlexWrap = styled(Flex)`
  gap: ${props => (props.gap ? props.gap : '0')};
  width: ${props => (props.width ? props.width : 'auto')};
`
export const MainWrap = styled(Flex)`
  background-color: ${COLORS.PRIMARY_GREY_T_98};
  position: relative;
`
export const HeaderWrap = styled(Flex)`
  padding: 30px;
  background-color: ${COLORS.BLUE_T_97};
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1;
`
export const ContentWrap = styled(Flex)`
  margin: 0 30px;
  background: ${COLORS.WHITE};
  border-radius: 8px;
`
export const Heading = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_40};
  margin-bottom: 0;
`
export const Info = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_BASE};
  line-height: 20px;
  color: ${COLORS.GREY_T_10};
  margin-bottom: 0;
  text-transform: capitalize;
`
export const VerticalDivider = styled(Divider)`
  height: ${props => (props.height ? props.height : '30px')};
  margin: 0 15px;
`
